const Constants = {
	cardTypes: {
		none: "none",
		visa: "visa",
		mast: "mast",
		amex: "amex",
		disc: "disc",
		all: "all",
	},
	billingTypes: {
		card: "card",
		paypal: "paypal",
	},
	billingActions: {
		attemptToBuy: "attemptToBuy",
		addBillingInfoAndBuy: "addBillingInfoAndBuy",
		addBillingInfo: "addBillingInfo",
	},
	cardNumberMaxLength: 19,
	errorText: {
		name: "That name wasn’t valid.",
		zipCode: "There’s a Zip code error.",
		cardNumber: "That card number isn’t valid.",
		securityCode: "That CVV isn’t valid.",
		expiration: "That expiration isn’t valid.",
		form: "We couldn’t bill that card!",
	},
	fields: [
		"name",
		"zipCode",
		"cardNumber",
		"securityCode",
		"expiration",
	],
	activePaymentMethod: {
		paypal: "paypal",
		creditcard: "card",
	},

	// map a property to the error codes that'll cause it to light up
	// use a hash index instead of a list so lookup is easier
	fieldErrorMap: {
		nameError: {
			"firstname": 1,
			"lastname": 1,
			"payment2034_showextra": 1,
			"payment10107": 1,
			"payment37": 1,
		},
		cardNumberError: {
			"number": 1,
			"payment11": 1,
			"payment12": 1,
			"payment17": 1,
			"payment34": 1,
			"payment2034": 1,
			"payment10251": 1,
			"payment10205": 1,
			"payment10257": 1,
			"payment10215": 1,
			"payment65204": 1,
			"number_nonnumbers": 1,
			"number_invalid": 1,
		},
		zipCodeError: {
			"zipCA": 1,
			"zipUS": 1,
			"zip": 1,
			"payment301": 1,
			"payment10107": 1,
		},
		expirationError: {
			"expired": 1,
			"expirationdate": 1,
			"expiration": 1,
			"payment15": 1,
			"payment16": 1,
			"payment17": 1,
		},
		securityCodeError: {
			"code": 1,
		},
	},
};

export default Constants;



// WEBPACK FOOTER //
// ./src/reflux/okpay/util/Constants.js